<template>
  <div class="main-pcrecuperarMercanciaVolcada">
    <div
      v-if="unidadLogisticaActiva != null"
      class="div-componentePCRecuperarMercanciaVolcadaVistaUL"
    >
      <div class="div-ttlNumeroSerie">
        <span class="span-ttlNumeroSerie">
          {{
            $t('production.dump.retrieve.view.logisticUnit.labels.serialNumber', {
              text: unidadLogisticaActiva.NumeroSerie,
            })
          }}
        </span>
      </div>
      <div style="width: 100%;">
        <f7-row>
          <f7-col width="80">
            <div
              v-if="unidadLogisticaActiva.Existencias != null && unidadLogisticaActiva.Existencias.length === 1"
              class="span-texto-azulOscuro-22-500 div-ttlPartidadDelPale"
            >
              {{ `${$t('common.batchPallet')}:` }}
            </div>
            <div
              v-if="unidadLogisticaActiva.Existencias != null && unidadLogisticaActiva.Existencias.length > 1"
              class="span-texto-azulOscuro-22-500 div-ttlPartidadDelPale"
            >
              {{ $t('production.dump.retrieve.view.logisticUnit.labels.multipleBatches') }}
            </div>
          </f7-col>
          <f7-col width="20">
            <span
              v-if="unidadLogisticaActiva.DatosOrigen != null"
              class="btn-oval-azulOscuro-26  seleccionable btn-informacionDatosOrigen"
              @click="AbrirDatosOrigenPale"
            >
              {{ $t('production.dump.retrieve.view.logisticUnit.labels.originData') }}
            </span>
          </f7-col>
        </f7-row>
      </div>

      <div
        v-if="existenciasRecuperablesUL.length > 0"
        class="div-registrosPartidas"
      >
        <div
          v-for="existencia in existenciasRecuperablesUL"
          :key="existencia.Id"
          class="div-registroPartida"
          @click="VerDetalle(existencia.Id)"
        >
          <div class="display-flex flex-direction-column">
            <div class="partidas-unidad">
              <span class="span-numeroPartidaVistaUL">
                {{ `${$t('common.batch').toUpperCase()} ${existencia.Partida.Id}/${existencia.Numero}` }}
              </span>
              <span class="span-envasesDisponibles">
                {{ $t('common.packages') }}
              </span>
            </div>
            <div class="partidas-unidad">
              <span class="span-productoPartida"> {{ existencia.DescripcionArticulo }} </span>
              <div>
                <img
                  class="img-iconoEnvases"
                  alt="iconEnvases"
                  src="@/static/icons/ic_box.svg"
                >
                <span class="span-existenciasEnvases">{{ existencia.CantidadEnvases }} </span>
              </div>
            </div>
          </div>
          <!-- <f7-row>
            <f7-col width="80">
              <span class="span-numeroPartidaVistaUL">PARTIDA {{ `${existencia.Partida.Serie}/${existencia.Numero}` }} </span>
            </f7-col>
            <f7-col
              width="20"
              class="col-envasesDisponibles"
            >
              <span class="span-envasesDisponibles">
                {{ $t('common.packages') }}
              </span>
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col
              width="70"
              class="col-productoPartida"
            >
              <span class="span-productoPartida"> {{ existencia.DescripcionArticulo }} </span>
            </f7-col>
            <f7-col
              width="30"
              class="col-cantidadEnvasesDisponibles"
            >
              <img
                class="img-iconoEnvases"
                alt="iconEnvases"
                src="@/static/icons/ic_box.svg"
              >
              <span class="span-existenciasEnvases">{{ existencia.CantidadEnvases }} </span>
            </f7-col>
          </f7-row> -->
        </div>
      </div>
      <!-- No existen existencias recuperables de la partida -->
      <div
        v-if="existenciasRecuperablesUL.length === 0"
        class="div-sinExistenciasRecuperables"
      >
        <span class="span-sinExistenciasRecuperables">
          {{ $t('production.dump.retrieve.view.logisticUnit.list.noStock') }}
        </span>
      </div>
      <!-- Botones de volcado -->
      <f7-row
        v-if="existenciasRecuperablesUL.length > 0"
        class="div-row-botonesDeVolcadoYRecuperado"
      >
        <f7-col width="100">
          <f7-button
            id="btn-recuperarTodo"
            fill
            class="btn-volcarTodo btn-color-oscuro-1 btn-tamaño-3"
            @click="RecuperarTodaLaMercanciaDeUnidadLogistica()"
          >
            {{ $t('production.dump.retrieve.view.logisticUnit.btnRetrieveEverythingText') }}
          </f7-button>
        </f7-col>
      </f7-row>

      <!-- popup-DatosOrigenPale -->
      <f7-popup
        class="popup-DatosOrigenPale"
        :opened="popupDatosOrigenPale"
        @popup:closed="popupDatosOrigenPale = false"
      >
        <f7-navbar
          :title="$t('production.dump.logisticUnit.originPalletDataPopup.title')"
          sliding
          :style="appTheme"
        >
          <f7-nav-right>
            <f7-link @click="popupDatosOrigenPale = false">
              {{ $t('common.x') }}
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div>
          <div class="div-contenidoPartidasDatosOrigen">
            <!-- Cabecera Formulario -->
            <div class="div-cabeceraContenidoDatosPartidaOrigen">
              <f7-row>
                <f7-col width="60">
                  <span class="span-ttlPartidasOrigen">
                    {{ $t('production.dump.logisticUnit.originPalletDataPopup.rowTitle') }}
                  </span>
                </f7-col>
              </f7-row>
            </div>
            <div class="div-elementoSeparador-total" />
            <f7-row class="row-elementosContenidoDatosPartidaOrden">
              <f7-col
                v-for="(datoOrigen, index) in unidadLogisticaActiva.DatosOrigen"
                :key="index"
                width="100"
              >
                <f7-col width="80">
                  <span class="span-texto-gris-1">
                    {{ `${$t('common.batch').toUpperCase()} ${datoOrigen.Partida.Serie}/${datoOrigen.Partida.Numero}` }}
                  </span>
                </f7-col>
              </f7-col>
            </f7-row>
          </div>
        </div>
      </f7-popup>
    </div>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import eventBus from '@/js/event-bus';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCRecuperarMercanciaVolcadaVistaUL',

  props: {
    actualizar: {
      type: Number,
      default: null,
    },
    unidadLogistica: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      existenciasRecuperablesUL: [],
      unidadLogisticaActiva: null,
      idUnidadLogisticaActiva: 0, // Contiene el Id de la unidad logistica activa.
      seleccionExistencia: null, // Contiene el elemento de volcado seleccionado (partida).
      idPartidaSeleccionada: 0,
      popupDatosOrigenPale: false, // Muestra el popup con la información de los datos origen.

    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),
    ...mapWritableState(useTraceabilityStore, ['partidaSeleccionada']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-orange)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  watch: {
    unidadLogistica(val) {
      if (val != null && val !== '' && val !== undefined) {
        this.idUnidadLogisticaActiva = val.Id;
        this.unidadLogisticaActiva = val;
        this.ObtenerElementosRecuperablesDeUnidadLogistica();
      }
    },
    actualizar(val) {
      if (val != null) {
        Log(this, this.actualizar.name);

        this.ObtenerElementosRecuperablesDeUnidadLogistica();
      }
    },
  },

  beforeUnmount() {
    this.partidaSeleccionada = null; // Eliminamos la unidadlogistica seleccionada al destruir.
  },

  methods: {
    VerDetalle(idExistencia) {
      Log(this, this.VerDetalle.name);
      [this.seleccionExistencia] = this.existenciasRecuperablesUL.filter((v) => v.Id === idExistencia);
      this.idPartidaSeleccionada = this.seleccionExistencia.Partida.Id;
      this.partidaSeleccionada = this.seleccionExistencia.Partida;
      /* this.ExistenciasVolcado = this.seleccionExistencia; */
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView');

      // f7.views.main.router.navigate('/trazabilidadAutomatizada/volcado/frmRecuperarMercanciaVolcadaVistaPartida');
    },

    AbrirDatosOrigenPale() {
      Log(this, this.AbrirDatosOrigenPale.name);
      this.popupDatosOrigenPale = true;
    },

    /**
     * @public
     * @returns {void}
     */
    ObtenerElementosRecuperablesDeUnidadLogistica() {
      Log(this, this.ObtenerElementosRecuperablesDeUnidadLogistica.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.retrieve.view.get.preloaderText'));
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      ConexionTA.callObtenerElementosRecuperablesArticuloNumeroSerie(puntoDeVolcado.Id, this.idUnidadLogisticaActiva).then((result) => {
        if (result.Valor) {
          self.existenciasRecuperablesUL = JSON.parse(result.Mensaje);

          if (self.existenciasRecuperablesUL.length > 0 && self.existenciasRecuperablesUL[0].TipoEntidadVolcada === 'NumeroSerie') {
            self.unidadLogisticaActiva.NumeroSerie = self.existenciasRecuperablesUL[0].NumeroSerie;
          }
          self.ComprobarSiLasExistenciasSonRecuperables();
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError('no se pudo obtener los elementos de unidad logistica', error);
        });
    },

    ComprobarSiLasExistenciasSonRecuperables() {
      Log(this, this.ComprobarSiLasExistenciasSonRecuperables.name);
      const auxExistencias = this.existenciasRecuperablesUL;
      const self = this;
      auxExistencias.forEach((element, index) => {
        if (element.CantidadEnvases === 0) {
          self.existenciasRecuperablesUL.splice(index, 1);
        }
      });
    },

    RecuperarTodaLaMercanciaDeUnidadLogistica() {
      Log(this, this.RecuperarTodaLaMercanciaDeUnidadLogistica.name);

      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.retrieve.view.retrieveEverything.preloaderText'));
      const lineaDeProduccion = this.lineaDeProduccionSeleccionada;
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      const elementosRecuperar = [];
      this.existenciasRecuperablesUL.forEach((existencia) => {
        const objEstructuraRecuperacion = {};
        objEstructuraRecuperacion.IdPartidaRecuperar = existencia.Partida.Id;
        objEstructuraRecuperacion.IdColaVolcadoRecuperar = existencia.Id;
        objEstructuraRecuperacion.CantidadCajasRecuperar = existencia.CantidadEnvases;
        elementosRecuperar.push(objEstructuraRecuperacion);
      });
      ConexionTA.callRecuperarMercanciaVolcadaDeUnidadLogistica(lineaDeProduccion.Id, puntoDeVolcado.Id, this.unidadLogisticaActiva.NumeroSerie, JSON.stringify(elementosRecuperar)).then((result) => {
        if (result.Valor) {
          self.unidadLogisticaActiva = JSON.parse(result.Mensaje);

          HiDialog.Preloader(false);
          self.NotificarVolcadoTotalRecuperada();
          HiNotification.Toast(this.$t('production.dump.retrieve.view.retrieveEverything.successToastText'));
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
          self.NotificarVolcadoTotalRecuperada();
        }
      })
        .catch((error) => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError('No se pudo recuperar la mercancia de unidad logistica', error);
        });
    },
    NotificarVolcadoTotalRecuperada() {
      Log(this, this.NotificarVolcadoTotalRecuperada.name);
      eventBus.emit('PCRecuperarMercanciaVolcadaUL_mercanciaTotalRecuperada');
    },
  },
};
</script>

<style lang="scss">
/* Nuevos Estilos */
.main-pcrecuperarMercanciaVolcada {
  .partidas-unidad {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 95vw;
  }

  .div-componentePCRecuperarMercanciaVolcadaVistaUL {
    margin: 15px;
    margin-top: 30px;
  }

  .div-ttlNumeroSerie {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .span-ttlNumeroSerie {
    color: var(--his-darkgray);
    font-size: 18px;
  }

  .div-registroPartida {
    padding-bottom: 15px;
    border-bottom: 1px solid var(--his-disabled);
    margin-bottom: 15px;
  }

  .span-numeroPartidaVistaUL {
    color: var(--his-darkgray);
    font-size: 18px;
  }

  .span-productoPartida {
    font-size: 18px;
    color: #009ba6;
    padding-top: 7px;
  }

  .span-envasesDisponibles {
    font-size: 20px;
    color: var(--his-silver);
    text-align: right;
    display: flex;
    justify-content: center;
  }

  .span-existenciasEnvases {
    font-size: 20px;
    color: #282829;
    text-align: right;
  }

  .col-cantidadEnvasesDisponibles {
    text-align: right;
  }

  .img-iconoEnvases {
    padding-top: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .btn-volcarTodo {
    margin-top: 12px;
    margin-bottom: 10px;
    margin-left: 20px;
    margin-right: 20px;
    max-width: 260px;
  }

  .span-sinExistenciasRecuperables {
    color: var(--his-ash-gray);
    font-size: 16px;
    text-align: center;
  }

  .div-row-botonesDeVolcadoYRecuperado {
    text-align: -webkit-center;
  }

  .btn-informacionDatosOrigen {
    display: flex;
    float: right;
  }

  .div-ttlPartidadDelPale {
    display: flex;
    float: left;
  }

  .div-contenidoPartidasDatosOrigen {
    margin-top: 38px;
    margin-left: 16px;
    margin-right: 10px;
  }

  .row-elementosContenidoDatosPartidaOrden {
    margin-top: 10px;
  }
}
</style>
